import React, { useState } from 'react';
import styles from './PagerDutyAppInfo.module.css';
import { Icon } from '@bookingcom/bui-react';
import { InfoSignIcon } from '@bookingcom/bui-assets-react/streamline';

const PagerDutyAppInfo = () => {
  const [seeMoreButtonContent, setSeeMoreButtonContent] = useState(false);
  return (
    <>
      <div className={styles.pagerDutyAppInfoContainer} data-testid={'appInfoDivTestId'}>
        <div className={styles.pagerDutyAppInfoSignMainContainer}>
          <Icon svg={InfoSignIcon} size={'large'} color="brand_genius_secondary" />
          <div className={styles.pagerDutyAppInfoContantContainer}>
            <p>
              <strong>{' What if the Crisis Panic Button On-Call page is not working?'}</strong>
            </p>
            {seeMoreButtonContent && (
              <p className={styles.alertInfo}>You can fallback to the following approaches:</p>
            )}
            {seeMoreButtonContent && (
              <ul>
                <li>
                  Follow ABU crisis playbook{' '}
                  <a
                    href={process.env.REACT_APP_PLAYBOOK_URL}
                    style={{ color: 'blue' }}
                    target={'_blank'}
                    rel="noopener noreferrer">
                    document
                  </a>.
                </li>
              </ul>
            )}
          </div>
        </div>
        <button
          className={styles.pagerDutyAppSeeMoreButton}
          onClick={() => setSeeMoreButtonContent(!seeMoreButtonContent)}>
          {seeMoreButtonContent ? 'Show less' : 'Show More'}
        </button>
      </div>
    </>
  );
};

export default PagerDutyAppInfo;
